let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("74Sbn")).then(() => parcelRequire('fCAPY'));